import client from '@/api/client';

import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export const FPR_FIND_FOR_START = 'financingProductRules/find_for_integrated_banks/START';
export const FPR_FIND_FOR_SUCCESS = 'financingProductRules/find_for_integrated_banks/SUCCESS';
export const FPR_FIND_FOR_FAILURE = 'financingProductRules/find_for_integrated_banks/FAILURE';

const financingProductRules = crudlModuleGenerator('financingProductRules', {
  customKeys: {
    list: 'financing_product_rules',
  },
  customEndpoints: {
    delete: '/financing_product_rules/:id/deactivate',
  },
  customMethods: {
    delete: 'get',
  },
});

export default {
  ...financingProductRules,

  state: {
    ...financingProductRules.state,

    findForIntegratedBanks: {
      loading: false,
      result: [],
      error: null,
    },
  },

  actions: {
    ...financingProductRules.actions,

    findForIntegratedBanks({ commit }, payload) {
      commit(FPR_FIND_FOR_START);

      return new Promise((resolve, reject) => {
        client.get('/financing_product_rules/find_for_integrated_banks', {
          params: {
            ...payload,
          },
        })
          .then((response) => {
            commit(FPR_FIND_FOR_SUCCESS, response);

            resolve(response);
          })
          .catch((error) => {
            commit(FPR_FIND_FOR_FAILURE, error);

            reject(error);
          });
      });
    },
  },

  mutations: {
    ...financingProductRules.mutations,

    [FPR_FIND_FOR_START](state) {
      state.findForIntegratedBanks.error = null;
      state.findForIntegratedBanks.result = [];
      state.findForIntegratedBanks.loading = true;
    },
    [FPR_FIND_FOR_SUCCESS](state, response) {
      state.findForIntegratedBanks.error = null;
      state.findForIntegratedBanks.result = response.data.financing_product_rules;
      state.findForIntegratedBanks.loading = false;
    },
    [FPR_FIND_FOR_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.findForIntegratedBanks.error = details;
      state.findForIntegratedBanks.result = [];
      state.findForIntegratedBanks.loading = false;
    },
  },
};
